/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespFollowSearchBanner_viewer$ref = any;
export type SbRespNullSearchResults_viewer$ref = any;
export type SbRespNullSearchResults_viewer = {
    readonly isShopByRoomEnabled: boolean | null;
    readonly " $fragmentRefs": SbRespFollowSearchBanner_viewer$ref;
    readonly " $refType": SbRespNullSearchResults_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespNullSearchResults_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isShopByRoomEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SHOP_BY_ROOM"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SHOP_BY_ROOM\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '139da617bdcacf3ff776971b449dbee9';
export default node;
